import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/components/Auth'
import Profile from '@/components/Profile/Profile'
import Dashboard from '@/components/Dashboard/Dashboard'
// import Products from '@/components/Products/Products'
import Registration from '@/components/Registration'
import RegistrationConfirm from '@/components/RegistrationConfirm'
import RecoverPasswordConfirm from '@/components/RecoverPasswordConfirm'
import Guest from '@/Guest'
import Home from '@/Home'
import Payments from '@/components/Payments'
import Invoice from '@/components/Invoice'
import Contacts from '@/components/Contacts'
import SubscriptionsConstructor from '@/components/SubscriptionsConstructor'
import PageNotFound from '@/components/PageNotFound'
import Subscriptions from '@/views/Subscriptions'
import store from '../store'

Vue.use(Router)

const isGuest = {
  path: '',
  name: 'Home',
  component: Guest,
  redirect: '/auth',
  meta: {
    isGuest: true
  },
  children: [
    {
      path: 'auth',
      name: 'Auth',
      component: Auth,
      meta: {
        isGuest: true
      }
    },
    {
      path: 'register',
      name: 'Register',
      component: Registration,
      meta: {
        isGuest: true
      }
    },
    {
      path: 'constructor',
      name: 'GuestConstructor',
      component: SubscriptionsConstructor,
      meta: {
        isGuest: true
      }
    }, {
      path: 'register/confirm',
      name: 'Confirm',
      component: RegistrationConfirm,
      meta: {
        isGuest: true
      }
    }, {
      path: 'confirmRecoverPassword',
      name: 'RecoverPasswordConfirm',
      component: RecoverPasswordConfirm,
      meta: {
        isGuest: true
      }
    }
  ]
}

const User = {
  path: '/',
  component: Home,
  name: 'Dashboard',
  redirect: '/dashboard',
  meta: {
    requiredAuth: true
  },
  children: [
    {
      path: 'dashboard',
      component: Dashboard,
      meta: {
        requiredAuth: true
      }
    },
    {
      name: 'Subscriptions',
      path: 'subscriptions',
      component: Subscriptions,
      meta: {
        requiredAuth: true
      }
    },
    {
      name: 'createSubscription',
      path: 'subscriptions/create',
      component: SubscriptionsConstructor,
      meta: {
        requiredAuth: true
      },
      beforeEnter: async (to, from, next) => {
        if (!store.state.config.data) {
          await store.dispatch('getConfig')
        }
        if (!store.state.config.data.allowCreateSubscription) {
          next(from.path || '/')
        }
        next()
      }
    },
    {
      name: 'editSubscription',
      path: 'subscriptions/:subscriptionId',
      component: SubscriptionsConstructor,
      meta: {
        requiredAuth: true
      },
      beforeEnter: async (to, from, next) => {
        if (!store.state.config.data) {
          await store.dispatch('getConfig')
        }
        if (!store.state.config.data.allowEditSubscription) {
          next(from.path || '/')
        }
        next()
      }
    },
    {
      name: 'Profile',
      path: 'profile',
      component: Profile,
      meta: {
        requiredAuth: true
      }
    },
    {
      path: 'payments',
      component: Payments,
      meta: {
        requiredAuth: true
      }
    },
    {
      path: 'invoice',
      component: Invoice,
      meta: {
        requiredAuth: true
      }
    },
    {
      path: 'contacts',
      component: Contacts,
      meta: {
        requiredAuth: true
      }
    }
  ]
}

const notFound = {
  path: '*',
  name: '404',
  component: PageNotFound
}

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '',
  routes: [ isGuest, User, notFound ],
  linkExactActiveClass: 'active'
})

export default router
